import PropTypes from "prop-types";
import React, { Component } from "react";
import Button from "@mui/material/Button";
import { DropdownMenu } from "react-dd-menu";

class CustomerFilterMenu extends Component {
  constructor() {
    super();
    this.state = {
      isMenuOpen: false
    };
    this.click = this.click.bind(this);
    this.clickCustomerId = this.clickCustomerId.bind(this);
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
  }

  componentWillUnmount(){
    this.toggle = () => {};
  }

  toggle() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }

  close() {
    this.toggle();
  }

  click(e) {
    this.props.onChange({
      term: "customer",
      title: e.currentTarget.innerText,
      code: e.currentTarget.id,
      id: ""
    });
    this.close();
  }

  clickCustomerId(e) {
    this.props.onChange({
      term: "customer",
      title: "Customer: " + e.currentTarget.innerText,
      code: "id",
      id: e.currentTarget.id
    });
    this.close();
  }

  render() {
    const menuOptions = {
      isOpen: this.state.isMenuOpen,
      close: this.close,
      toggle: <Button onClick={this.toggle}>{this.props.title}</Button>,
      align: "left",
    };

    // TODO: get a real list of customers here these are the live ids
    let hst = window.location.hostname;
    let customers = [];
    if (hst.includes("test")) {
      customers = [
        { id: 1325, name: "Allstate Appraisal (MUE_AP)" },      
        { id: 1326, name: "Allstate Appraisal (MUI_AP)" },      
        { id: 1331, name: "Better Mortgage" },      
        { id: 1359, name: "Dart Appraisal" },      
        { id: 1320, name: "Dwellworks" },      
        { id: 1321, name: "Fannie Mae" },      
        { id: 991331, name: "First Financial Bank" },  // does not exist in TEST
        { id: 1172, name: "Mueller Appraisal" },      
        { id: 1323, name: "United Wholesale Mortgage" },      
      ];
    }
    else if (hst.includes("local") || hst.includes("dev")) {
      customers = [
        { id: 1427, name: "Allstate Appraisal (MUE_AP)" },      
        { id: 1428, name: "Allstate Appraisal (MUI_AP)" },      
        { id: 1364, name: "Better Mortgage" },      
        { id: 1359, name: "Dart Appraisal" },      
        { id: 1409, name: "Dwellworks" },      
        { id: 1356, name: "Fannie Mae" },      
        { id: 991331, name: "First Financial Bank" },  // does not exist in DEV
        { id: 1255, name: "Mueller Appraisal" },      
        { id: 1357, name: "United Wholesale Mortgage" },      
      ];      
    }
    else {
      customers = [
        { id: 1427, name: "Allstate Appraisal (MUE_AP)" },      
        { id: 1428, name: "Allstate Appraisal (MUI_AP)" },      
        { id: 1466, name: "Better Mortgage" },      
        { id: 1359, name: "Dart Appraisal" },      
        { id: 1409, name: "Dwellworks" },      
        { id: 1406, name: "Fannie Mae" },      
        { id: 1252, name: "First Financial Bank" }, 
        { id: 1202, name: "Mueller Appraisal" },      
        { id: 1407, name: "United Wholesale Mortgage" },      
      ];
    }
    return (
      <DropdownMenu {...menuOptions}>
        <li><a href="#" id="all" onClick={this.click}>All Customers</a></li>
        <li role="separator" className="separator" />
        { 
          customers.map(item => (<li key={item.id}><a href="#" id={item.id} onClick={this.click}>{item.name}</a></li>))
        }
        <li role="separator" className="separator" />
        <li><a href="#" id="allinternal" onClick={this.click}>All Include Internal</a></li>
      </DropdownMenu>
    );
  }
}

CustomerFilterMenu.propTypes = {
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export default CustomerFilterMenu;